<div class="form-floating">
  @if (inputElem.isReadonly) {
    <input
      type="text"
      class="form-select"
      [attr.id]="inputElem.name"
      [attr.name]="inputElem.name"
      [attr.data-test]="'form-input-' + inputElem.name"
      [attr.readonly]="isLoading || inputElem.isReadonly ? 'readonly' : null"
      [attr.aria-describedby]="ariaDescribedBy || null"
      [attr.aria-invalid]="!isValid"
      [attr.placeholder]="inputElem.placeholder | translate"
      [attr.style]="inputElem.inputStyle || null"
      [required]="isRequired || null"
      [formControl]="parentForm.controls[inputElem.name]"
      [ngClass]="{
        'is-invalid': parentForm.controls[inputElem.name].errors && !parentForm.controls[inputElem.name].pristine,
      }"
    />
  } @else {
    <select
      class="form-select"
      [ngClass]="{
        'is-invalid': parentForm.controls[inputElem.name].errors && !parentForm.controls[inputElem.name].pristine,
      }"
      [attr.id]="inputElem.name"
      [attr.name]="inputElem.name"
      [attr.data-test]="'form-input-' + inputElem.name"
      [attr.disabled]="inputElem.isDisabled ? '' : null"
      (change)="selectChanged.emit({ option: getOptionByValue($event.target.value), name: inputElem.name })"
      [attr.aria-describedby]="ariaDescribedBy || null"
      [attr.aria-invalid]="!isValid"
      [attr.style]="inputElem.inputStyle || null"
      [required]="isRequired || null"
    >
      @if (inputElem.placeholder) {
        <option [attr.disabled]="isRequired ? 'disabled' : null" [attr.hidden]="isRequired ? 'disabled' : null">
          {{ inputElem.placeholder | translate }}
        </option>
      }
      @for (option of inputElem.options; track option.value) {
        <option
          [value]="option.value"
          [attr.data-test]="inputElem.name + '-option-' + option.value"
          [selected]="isSelected(option)"
          [disabled]="isLoading && !isSelected(option)"
        >
          {{ option.text | translate }}
        </option>
      }
    </select>
  }
  @if (inputElem.labelKey) {
    <label [attr.for]="inputElem.name" class="form-label" [ngClass]="inputElem.labelCss" [translate]="inputElem.labelKey"></label>
  }
</div>
